var map = {
	"./carrot_collapse.svg": "1962",
	"./carrot_expand.svg": "3339",
	"./checkmark_icon.svg": "c9fa",
	"./ev_icon.svg": "1ccd",
	"./incorrect_icon.svg": "e637",
	"./traditional_icon.svg": "3776",
	"./web_icon.svg": "4834"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";